import { bool, func, number, string } from 'prop-types'
import React, { forwardRef } from 'react'

import './CustomDateInput.less'

const CustomDateInput = forwardRef(
  (
    {
      className = '',
      isOpen,
      screenReaderInputMessage,
      showClearDate,
      resetDate,
      selectsRange,
      endPlaceholder,
      focusedLabel,
      endDateId,
      onLabelClick,
      showIcon,
      ...props
    },
    ref,
  ) => {
    const [startValue, endValue] = props.value.split(' - ')

    return (
      <div
        className={`ra-dateinput form-control ${
          showClearDate ? 'ra-dateinput--with-close' : ''
        } ${showIcon ? 'ra-dateinput--with-icon' : ''} ${className}`}
      >
        <input {...props} ref={ref} className={`ra-dateinput__input`} />
        <label
          className={`ra-dateinput__label ${
            focusedLabel === props.id || (!focusedLabel && isOpen)
              ? 'ra-dateinput__label--open'
              : ''
          }`}
          htmlFor={props.id}
          onClick={() => onLabelClick?.(props.id)}
        >
          {startValue || props.placeholder}
        </label>
        {selectsRange && (
          <>
            <i className="ra-dateinput__arrow fa fa-long-arrow-right" />
            <label
              className={`ra-dateinput__label ${
                focusedLabel === endDateId ? 'ra-dateinput__label--open' : ''
              }`}
              htmlFor={props.id}
              onClick={() => onLabelClick?.(endDateId)}
            >
              {endValue || endPlaceholder}
            </label>
          </>
        )}
        {screenReaderInputMessage && (
          <p className="ra-dateinput__screen-reader-only">
            {screenReaderInputMessage}
          </p>
        )}
      </div>
    )
  },
)

CustomDateInput.displayName = 'CustomDateInputForwardRef'

CustomDateInput.propTypes = {
  screenReaderInputMessage: string,
  className: string,
  showClearDate: bool,
  isOpen: bool,
  'aria-describedby': string,
  'aria-invalid': bool,
  'aria-labelledby': string,
  'aria-required': bool,
  placeholderText: string,
  selectsRange: bool,
  autoComplete: bool,
  endPlaceholder: string,
  autoFocus: bool,
  disabled: bool,
  form: string,
  id: string,
  endDateId: string,
  name: string,
  onBlur: func,
  onChange: func,
  onLabelClick: func,
  showIcon: bool,
  resetDate: func,
  onClick: func,
  onFocus: func,
  onKeyDown: func,
  placeholder: string,
  readOnly: bool,
  required: bool,
  tabIndex: number,
  title: string,
  value: string,
  focusedLabel: string,
}

export { CustomDateInput }
